import React from 'react';

import { DefaultView, EditView, Views as BlockWithViews } from '../../types/BlockWithViews';
import { asFetchableBlock, useBlockContext } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import {
  BlockInteractions,
  createButtonObject,
  DISPLAY_TYPE,
  Views,
} from '../../components/organisms/BlockInteractions';
import { Icons } from '../../components/atoms/SVG';
import { NewsletterfooterEditView } from './views/NewsletterfooterEditView';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { PortalSettingsDefaultView } from '../../_lib/components/PortalSettingsDefaultView';
import { HeadingHierarchy } from '../../_lib/components/Heading/Heading';

type NewsletterfooterSettings = BlockWithViews<
  DefaultView<{ value: string; noContentMessage: string }> & EditView<any>
>;
function Newsletterfooter({ views, activeView }: NewsletterfooterSettings) {
  const { t } = useSonTranslation('Newsletterfooter');
  const { uuid, elementType } = useBlockContext();

  const headline: { text: string, hierarchy: HeadingHierarchy, visible: true } = {
    text: t('headline'),
    hierarchy: 2,
    visible: true,
  };

  const buttons = createButtonObject(
    Views.EDIT,
    Icons.EDIT_PENCIL,
    `Newsletterfooter:edit`,
    DISPLAY_TYPE.COLLAPSIBLE,
    <NewsletterfooterEditView {...views.edit} />,
  );

  return (
    <BlockInteractions
      headline={headline}
      alwaysShowInfo
      views={views}
      activeView={activeView}
      buttons={buttons}
      uuid={uuid}
      elementType={elementType}
    >
      <PortalSettingsDefaultView {...views.default} noContentMessage={t('noContent')} />
    </BlockInteractions>
  );
}

export const NewsletterfooterBlock = asFetchableBlock(Newsletterfooter, BlockType.newsletterfooter);
